import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../utilities/requestClient';
import { LiquidityUrls } from '../fundAssetLiquidationTime/FundAssetLiquidationTimePage';
import type { RstEvolutionSeriesPayload } from './chart/rstChart.data';
import { RSFundPageModel } from '../../../../types/server-data/ClientConfig';

export type RstEvolutionPageModel = RSFundPageModel<RstEvolutionSeriesPayload>;

export function useRstEvolutionPageModel(
  fundId: string,
  date1: string,
  date2: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['rst-evolution', fundId, date1, date2] as const,
    queryFn: async () => {
      const url = `${LiquidityUrls.FETCH_RST}/${fundId}/${date1}/${date2}`;
      const { data } = await AxiosInstance.get<RstEvolutionPageModel>(url);
      return data;
    },
    enabled: (options?.enabled ?? true) && !!fundId && !!date1 && !!date2,
    staleTime: 1000 * 60 * 5,
  });
}
